import React, { useEffect } from 'react';
import { Main } from '@components/Main';
import { TypographyContainer } from '@components/Typography';
import { withTrans } from '@i18n/withTrans';

const Typography = ({ i18n, pageContext }) => {
  
  useEffect(() => {
    i18n.changeLanguage(pageContext.lang)
  }, [i18n, pageContext])

  return (
    <Main pageContext={pageContext}>
      <TypographyContainer/>
    </Main>
  )
}

const TypographyPage = withTrans(Typography);

export default TypographyPage 
